import useBurnRequests3Step from '@hooks/queries/registry/burn/useBurnRequests';
import useRegistrarService from '@hooks/queries/registry/onboarding/useRegistrarService';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundBurnRequests = () => {
  const r = useBurnRequests3Step();
  const { party } = useParties();
  const registrarService = useRegistrarService();
  const isRegistrar = !!registrarService.data;
  const filtered = r.data?.filter((request) => request.payload.burn.registrar === party);
  if (!isRegistrar) {
    return [];
  }
  return filtered || [];
};
